import { createZodDto } from "nestjs-zod/dto";

import { z } from "zod";

import { userSchema } from "../user";
import { extend } from "dayjs";

export const newUserSchema = userSchema.pick({ name: true, email: true, isInternal: true }).extend({
  password: z.string().min(8).optional(),
  /** Rôle initial (utilisateur interne) — appliqué par le backend à la création. */
  roleId: z.string().optional(),
});

export class ManualCreateUserDto extends createZodDto(newUserSchema) {}
